export const parseVersion = (version: number) =>
  `${version}`.replace(/^(\d{4})(\d{2})(\d{2,2})([^$]*)/, `$1-$2-$3`);
